import Vue from 'vue';
import Router from 'vue-router';
import Layout from "@/layout";
Vue.use(Router);

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/other/login"),
  },
  {
    path: "/",
    component: Layout,
    meta: { title: "我的首页" },
    redirect: "/dashboard/index",
    name: "index",
  },
  {
    path: "/dashboard",
    component: Layout,
    meta: { title: "我的首页" },
    redirect: "/dashboard/index",
    name: "dashboard",
    children: [
      {
        path: "index",
        component: () => import("@/views/dashboard/index"),
        name: "dashboard_index",
        meta: { title: "我的首页" }
      }
    ]
  },
  {
    path: "/notice",
    component: Layout,
    meta: { title: "通知" },
    redirect: "/notice/index",
    name: "notice",
    children: [
      {
        path: "index",
        component: () => import("@/views/notice/index"),
        name: "notice_index",
        meta: { title: "交易会" }
      }
    ]
  },
  {
    path: "/signup",
    component: Layout,
    meta: { title: "报名" },
    redirect: "/signup/index",
    name: "signup",
    children: [
      {
        path: "index",
        component: () => import("@/views/signup/index"),
        name: "signup_index",
        meta: { title: "报名" }
      }
    ]
  },
  {
    path: "/auth",
    component: () => import("@/views/other/auth"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  { path: "*", redirect: "/404", hidden: true }
];

routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
